import store from '@/store';
export const option = {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchIcon: true,
  searchIndex: 7,
  searchLabelWidth: 100,
  column: [
    {
      label: "进件编号",
      prop: "businessCode",
      type: "input",
      search: true,
      width: 125,
      searchOrder: 988,
    },
    {
      label: "租赁人",
      prop: "name",
      type: "input",
      search: true,
      slot: true,
      width: 100,
      searchOrder: 997,
    },
    {
      label: "所属代理商",
      prop: "deptName",
      type: "input",
      width: 120,
    },
    {
      label: "手机号",
      prop: "phoneNumber",
      type: "input",
      // search: true,
      width: 100,
    },
    {
      label: "产品类型",
      prop: "rentType",
      type: "select",
      dicData: store.getters.porductTypes,
      width: 100,
    },
    {
      label: "产品类型",
      prop: "rentTypeList",
      type: "select",
      dicData: store.getters.porductTypes,
      searchMultiple: true,
      hide: true,
      search: true,
      searchOrder: 999,
      cascader: ['lendingRate']
    },
    {
      label: "车牌号",
      prop: "carFirstNumber",
      type: "input",
      search: true,
      slot: true,
      searchOrder: 996,
      width: 105,
    },
    {
      label: "租赁金额",
      prop: "lendingAmount",
      type: "number",
      controls: false,
      // search: true,
    },
    {
      label: "租金总额",
      prop: "lendingAmountWithRate",
      type: "input",
    },
    {
      label: "资方",
      prop: "platformName",
      type: "select",
      dicData: [
        {
          label: "若磐",
          value: 0
        },
        {
          label: "程力",
          value: 1
        },
        {
          label: "楚钧",
          value: 4
        },
        {
          label: "品融",
          value: 5
        }
      ],
      width: 60,
    },
    {
      label: "放款金额进度",
      prop: "lendingAmountProcess",
      type: "input",
      slot: true,
      width: 140
    },
    {
      label: "放款金额明细",
      prop: "lendingTypeAmountList",
      type: "input",
      slot: true,
      width: 80
    },
    {
      label: "放款笔数进度",
      prop: "lendingCount",
      type: "input",
      slot: true,
    },
    {
      label: "租期",
      prop: "tenancy",
      type: "input",
      width: 60,
      formatter:(val,value,label)=>{
        return value ? value + "期" : "-";
      }
    },
    {
      label: "每期租金",
      prop: "lendingAmountPer",
      type: "input",
      width: 100,
    },
    {
      label: "租率",
      prop: "lendingRate",
      type: "input",
      width: 70,
      formatter:(val,value,label)=>{
        return value ? value + "%" : "-";
      }
    },
    {
      label: "起租日",
      prop: "commencementDate",
      type: "input",
      width: 95,
    },
    {
      label: "审核节点",
      prop: "auditNode",
      slot: true,
      width: 150,
    },
    {
      label: "节点名称",
      prop: "taskDefinitionKeyList",
      type: "select",
      search: true,
      searchMultiple: true,
      searchClearable: true,
      hide: true,
      addDisplay: false,
      editDisplayf: false,
      viewDisplay: false,
      width: 150,
      dicData: [],
      searchOrder: 990,

    },
    {
      label: "创建人",
      prop: "createUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "所属代理商",
      prop: "createDept",
      type: "select",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },
    {
      label: "新增日期",
      prop: "commitTimeRange",
      type: "daterange",
      search: true,
      searchRange: true,
      dataType: "string",
      // hide: true,
      valueFormat: "yyyy-MM-dd",
      searchOrder: 995,
    },
    {
      label: "是否重复",
      prop: "isRepeat",
      type: "select",
      search: true,
      searchOrder: 993,
      dicData: [
        {
          label: "重复",
          value: 1
      },
      {
          label: "不是",
          value: 2
      }
      ]
    },
    {
      label: "是否省代",
      prop: "provincialRepresentative",
      type: "select",
      search: true,
      searchOrder: 992,
      dicData: [
        {
          label: "是",
          value: 1
      },
      {
          label: "否",
          value: 0
      }
      ]
    },
    {
      label: "起租日",
      prop: "commencementDateRange",
      type: "daterange",
      search: true,
      searchRange: true,
      dataType: "string",
      hide: true,
      valueFormat: "yyyy-MM-dd",
      searchOrder: 994,
    },
    // {
    //   label: "创建时间",
    //   prop: "updateTime",
    //   type: "input",
    //   addDisplay: false,
    //   editDisplay: false,
    //   viewDisplay: false,
    //   hide: true,
    //   width: 90,
    // },
    {
      label: "修改人",
      prop: "updateUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "上一笔放款时间",
      prop: "updateTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: false,
      width: 140,
    },
    {
      label: "状态",
      prop: "status",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "是否已删除",
      prop: "isDeleted",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    // {
    //   label: "所属代理商",
    //   prop: "deptName",
    //   type: "input",
    // },
  ],
};

//根据角色权限来展示
export const jurisdictionDifferentiate = {
  finance: [
    {
      title: '租赁人',
      value: 'name',
      order: 1,
    },
    {
      title: '所属代理商',
      value: 'deptName',
      order: 2,
    },
    {
      title: '产品类型',
      value: 'rentType',
      order: 3,
    },
    {
      title: '车牌号',
      value: 'carFirstNumber',
      order: 4,
    },
    {
      title: '租赁金额',
      value: 'lendingAmount',
      order: 5,
    },
    {
      title: '租金总额',
      value: 'lendingAmountWithRate',
      order: 6,
    },
    {
      title: '放款金额进度',
      value: 'lendingAmountProcess',
      order: 7,
    },
    {
      title: '放款金额明细',
      value: 'lendingTypeAmountList',
      order: 8,
    },
    {
      title: '放款笔数进度',
      value: 'lendingCount',
      order: 9,
    },
    {
      title: '租期',
      value: 'tenancy',
      order: 10,
    },
    {
      title: '每期租金',
      value: 'lendingAmountPer',
      order: 11,
    },
    {
      title: '租率',
      value: 'lendingRate',
      order: 12,
    },
    {
      title: '起租日',
      value: 'commencementDate',
      order: 13,
    },
    {
      title: '是否省代',
      value: 'provincialRepresentative',
      order: 14,
    },
    {
      title: '创建时间',
      value: 'updateTime',
      order: 15,
    },
    {
      label: "新增日期",
      value: "commitTimeRange",
      order: 16,
    },
    {
      title: '审核节点',
      value: 'auditNode',
      order: 17,
    },
  ],
};
